export default {

  SETORDERALLIST(state, data) {
    state.onlineOrder.totalList = []
    state.onlineOrder.totalList = data
  },

  SETPAGEMANAGEMENTORDERAALL(state, data) {
    state.onlineOrder.pageManagement = data
  },

  SETPAGEMANAGEMENTORDERAALLV(state, data) {
    state.onlineOrder.pageManagementV = data
  },

  SETFINDPRODUCT(state, data) {
    data.unshift({
      name: "全部",
      id: 0
    })
    state.onlineOrder.productList = data
  },


  SETFINDPAYTYPE(state, data) {
    data.unshift({
      name: "全部",
      id: 0
    })
    state.onlineOrder.payTypeList = data
  },

  SETLOGLIST(state, data) {
    state.onlineOrder.logList = []
    data.forEach((item, index) => {
      item.index = index + 1;
    })
    state.onlineOrder.logList = data
  },

  SETPAGEMANAGEMENTLOG(state, data) {
    state.onlineOrder.pageManagementLog = data
  },

  SETLOGNUMBER(state, data) {
    state.onlineOrder.numberLog = data
  },

  SETTITLE(state, data) {
    state.onlineOrder.title = data
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/OnlineOrder/mutations.js